import { ClipboardDocumentListIcon, PlusIcon } from '@heroicons/react/24/outline';
import ButtonComponent from '../customButton';
import { TEST_GROUP_CASES_EMPTY_CONTENT } from './testGroupDetailOverview.constants';
import styles from '../../styles/testGroupDetail/testGroupCasesEmptyPanel.module.scss';

export default function TestGroupCasesEmptyPanel({ onAddTestCases }) {
  const content = TEST_GROUP_CASES_EMPTY_CONTENT;
  const isAddDisabled = typeof onAddTestCases !== 'function';

  return (
    <div className={styles.container}>
      <div className={styles.iconSection}>
        <ClipboardDocumentListIcon className={styles.icon} aria-hidden="true" />
      </div>
      <h3 className={styles.title}>{content.title}</h3>
      <p className={styles.description}>{content.description}</p>
      <ButtonComponent
        ctaText={content.ctaLabel}
        variant="primary"
        className="white bg-blue600"
        startIcon={<PlusIcon className="icon" />}
        onClick={onAddTestCases}
        disabled={isAddDisabled}
        size="small"
      />
    </div>
  );
}
